import { COMMON_ENTITIES } from 'src/utils/entityDefinitions/entities/commonEntities';

export const ATLAS_ENTITIES = {
  ...COMMON_ENTITIES
};
